import React, { Component } from 'react';
import { AppBar, Toolbar, Typography, IconButton, withTheme } from 'material-ui';
import { Book, Dashboard, Settings } from '@material-ui/icons';
import { Link } from 'react-router-dom';
import EnhancedTooltip from './EnhancedTooltip';

class NavHeader extends Component {  
  render() {
    return (
      <AppBar position="fixed">
        <Toolbar>
          <Typography variant="title" color='inherit' style={{flexGrow: 1}}>
          <Link to='/' style={{color: 'inherit', textDecoration: 'none' }}>Open FIRST Resources</Link>
          </Typography>

          <EnhancedTooltip title="Resources">{/*TODO Tab-Enter doesn't work for these*/}
            <IconButton color='inherit' component={Link} to='/resources'>
              <Dashboard/>
            </IconButton>
          </EnhancedTooltip>

          <EnhancedTooltip title="Glossary">
            <IconButton color='inherit' component={Link} to='/glossary'>
              <Book/>
            </IconButton>
          </EnhancedTooltip>

          <EnhancedTooltip title="Configure Bundles">
            <IconButton color='inherit' component={Link} to='/settings'>
              <Settings/>
            </IconButton>
          </EnhancedTooltip>
          
        </Toolbar>

        {null}
      </AppBar>
    );
  }
}

export default withTheme()(NavHeader);


// WEBPACK FOOTER //
// ./src/components/NavHeader.js